import { createFileRoute, redirect } from '@tanstack/react-router'
import { AppRoute } from 'appRoutes'

export const Route = createFileRoute('/_authenticated/_layout/(deprecated)/workspaces/$subscriptionId/visits')({
  beforeLoad: ({ params: { subscriptionId } }) => {
    return redirect({ to: AppRoute.IdentificationEvents, params: { subscriptionId }, search: true, replace: true })
  },
})
